import type {Workshop} from '~/types/legacy'
import type {Populated} from '~/types/populated'

export function useWorkshop() {
  const sdk = usePayloadSdk()
  const route = useRoute()

  const fetch = async () => {
    const result = await sdk.findGlobal({
      slug: 'workshopGlobal',
      depth: 4,
      draft: !!route.query.preview,
    })

    return result as Populated<Workshop>
  }

  return {fetch}
}
